import { IDocumentSource, ILayerColumn, ITableColumn } from '../../../types';
import { IBaseNode, NodeType } from '../IBaseNode';

export class NearbyAssetNode implements IBaseNode {
    public id: number;
    public title: string;
    public name: string;
    public description: string;
    public joinKey: string;
    public parentJoinKey: string;
    public layerId: number;
    public tableId: number;
    public templates: any[];
    public sources: IDocumentSource[];
    public link: string;
    public columns: (ILayerColumn | ITableColumn)[];
    public columnList: string[];
    public record: any;

    public documentLoaded: boolean;
    public enabled: boolean;
    public searchText: string;
    public orderBy: string;
    public asc: boolean;

    public graphic: __esri.Graphic;
    public lngLat: any;

    constructor({
        id = null,
        title = null,
        name = null,
        joinKey = null,
        parentJoinKey = null,
        layerId = null,
        tableId = null,
        description = null,
        templates = null,
        sources = null,
        link = null,
        columns = null,
        columnList = null,
        record = null }: Partial<NearbyAssetNode> = {}
    ) {
        this.id = id;
        this.title = title;
        this.name = name;
        this.joinKey = joinKey;
        this.parentJoinKey = parentJoinKey;
        this.layerId = layerId;
        this.tableId = tableId;
        this.description = description;
        this.templates = templates;
        this.sources = sources;
        this.link = link;
        this.columns = columns;
        this.columnList = columnList;
        this.record = record;
    }

    public get nodeType(): NodeType {
        let type = NodeType.Category;
        if (this.layerId) {
            type = NodeType.Layer;
        } else if (this.tableId) {
            type = NodeType.Table;
        } else if (this.record) {
            if (Array.isArray(this.record)) {
                type = NodeType.Record;
            } else {
                type = NodeType.Document;
            }
        }
        return type;
    }
}
